<template>
  <mf-loading-dialog :loading="isLoadingCampaign">
    <base-page-layout :title="!isFinished ? 'Nova campanha' : 'Visualizar campanha'" show-tour flow-id="95987f74-ccfe-40ba-be67-fb8ae7c5028e">
      <coupon-discount-title :campaign="campaign" :validations="$v" />
      <div class="date-units-cards">
        <coupon-discount-date :campaign="campaign" :validations="$v" />
        <coupon-discount-units :campaign="campaign" :validations="$v" />
      </div>
      <coupon-discount-configs :campaign="campaign" :validations="$v" />
      <coupon-discount-model
        :campaign="campaign"
        :validations="$v"
        :valid-coupon.sync="validCoupon"
        :loading="isLoadingCouponValidation"
        @loading="isLoadingCouponValidation = $event"
      />
      <mf-action-buttons
        class="mt-2"
        :primary-button="primaryButton"
        :secondary-button="secondaryButton"
        :extra-button="deleteButton"
        :cancel-button="cancelButton"
      />
    </base-page-layout>
  </mf-loading-dialog>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import CouponDiscountTitle from '../components/edit/CouponDiscountTitle.vue'
import CouponDiscountDate from '../components/edit/CouponDiscountDate.vue'
import CouponDiscountUnits from '../components/edit/CouponDiscountUnits.vue'
import CouponDiscountConfigs from '../components/edit/CouponDiscountConfigs.vue'
import CouponDiscountModel from '../components/edit/CouponDiscountModel.vue'
import Swal from 'sweetalert2'

import { required, minLength, minValue, maxLength } from 'vuelidate/lib/validators'
import { notOnlySpace, isFuture } from '@/helpers/validators.js'
import { deepDelete } from '@/helpers/deepDelete'
import { UPSERT_DRAFT_BENEFIT, UPSERT_BENEFIT, QUERY_FIND_BENEFIT_BY_ID, UNSCHEDULE_BENEFIT, FINISH_ACTIVE_BENEFIT, DELETE_BENEFIT } from '../../graphql'
import { DateTime } from 'luxon'

export default {
  name: 'CoupomDiscount',
  components: {
    BasePageLayout,
    CouponDiscountTitle,
    CouponDiscountDate,
    CouponDiscountUnits,
    CouponDiscountConfigs,
    CouponDiscountModel,
  },
  data: () => ({
    tryingToSaveAsDraft: false,
    loading: false,
    isLoadingCampaign: false,
    isLoadingCouponValidation: false,
    DateTime,
    validCoupon: null,
    campaign: {
      title: '',
      description: '',
      status: '',
      appTitle: '',
      startDate: '',
      expiresAt: '',
      variableValidity: false,
      daysToUseBenefitAfterRegistration: 1,
      units: [],
      value: null,
      minimumValue: null,
      minimumProducts: 1,
      productsEnabled: false,
      model: 'MANUAL',
      code: '',
      limitUse: 0,
      type: 'DISCOUNT_COUPON_ABSOLUTE',
      products: [],
    },
  }),
  computed: {
    isFinished() {
      return this.campaign.status === 'FINISHED'
    },

    primaryButton() {
      const button = {
        isVisible: true,
        isDisabled: this.isFinished,
        isLoading: this.loading || this.isLoadingCouponValidation,
        action: () => this.saveCampaign(false),
      }

      switch (this.campaign.status) {
        case 'ACTIVE':
        case 'SCHEDULED':
          button.text = 'Salvar alterações'
          break
        default:
          button.text = 'Ativar campanha'
      }

      return button
    },

    secondaryButton() {
      const button = {
        isVisible: true,
        isDisabled: this.isFinished,
        isLoading: this.loading || this.isLoadingCouponValidation,
      }

      switch (this.campaign.status) {
        case 'ACTIVE':
          button.text = 'Finalizar'
          button.action = () => this.mutateBenefit('finish')
          break
        case 'SCHEDULED':
          button.text = 'Suspender'
          button.action = () => this.mutateBenefit('unschedule')
          break
        case 'DRAFT':
          button.text = 'Salvar alterações'
          button.action = () => this.saveCampaign(true)
          break
        default:
          button.text = 'Salvar rascunho'
          button.action = () => this.saveCampaign(true)
      }
      return button
    },

    cancelButton() {
      const button = {
        action: this.returnToCampaigns,
        isVisible: true,
        isDisabled: false,
        isLoading: this.loading || this.isLoadingCouponValidation,
      }

      switch (this.campaign.status) {
        case 'ACTIVE':
        case 'FINISHED':
          button.text = 'Fechar'
          break
        default:
          button.text = 'Cancelar'
      }

      return button
    },

    deleteButton() {
      return {
        text: 'Apagar rascunho',
        action: () => this.mutateBenefit('delete', this.campaign.title),
        isVisible: this.campaign.status === 'DRAFT',
        isDisabled: false,
        isLoading: this.loading || this.isLoadingCouponValidation,
      }
    },
    preparePayload() {
      const formatFloat = (value) => {
        const formattedValue = value.replace('.', '')
        return parseFloat(formattedValue.replace(',', '.'))
      }
      const campaign = {
        ...this.campaign,
        value: formatFloat(this.campaign.value),
        minimumValue: formatFloat(this.campaign.minimumValue),
        products: this.campaign.productsEnabled ? this.ungroupedProducts.map((product) => product.sku) : [],
        productsGroups: this.campaign.productsEnabled
          ? this.groupedProducts.map((group) => {
              return {
                groupId: group._id,
                skus: group.products.map((product) => product.sku),
              }
            })
          : [],
      }
      if (!this.campaign.startDate || !this.campaign.expiresAt) {
        deepDelete(campaign, ['startDate', 'expiresAt'])
      }
      if (!this.campaign.variableValidity) {
        deepDelete(campaign, ['daysToUseBenefitAfterRegistration'])
      }
      deepDelete(campaign, ['__typename', 'status', 'image', 'brands', 'id'])
      return campaign
    },
    isFranchise() {
      return this.$getLoggedUser().is_franchise
    },
    isFranchisee() {
      return this.$getLoggedUser().is_franchisee
    },
    ungroupedProducts() {
      if (!this.campaign.products) return []
      return this.campaign.products.filter((product) => !product.isGroup)
    },
    groupedProducts() {
      if (!this.campaign.products) return []
      return this.campaign.products.filter((product) => product.isGroup)
    },
  },
  async mounted() {
    if (this.isFranchisee) this.returnToCampaigns()
    const id = this.$route.params.id
    if (id) {
      await this.getData(id)
    }
  },
  methods: {
    returnToCampaigns() {
      this.$router.push('/campanhas/cupom-desconto')
    },
    async getData(id) {
      const formatFloatToString = (value) => {
        if (Number.isInteger(value)) return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        else return value.toFixed(2).replace('.', ',')
      }
      try {
        this.isLoadingCampaign = true
        const {
          data: { findBenefitById },
        } = await this.$apollo.mutate({
          mutation: QUERY_FIND_BENEFIT_BY_ID,
          fetchPolicy: 'no-cache',
          variables: {
            id,
            franchise: this.isFranchise,
          },
          context: {
            uri: this.$microservicesUrls['benefitsManager'],
          },
        })
        const { status } = findBenefitById
        const disabled = status === 'ACTIVE'
        const products =
          findBenefitById.products && findBenefitById.products.length
            ? findBenefitById.products.map((item) => ({ ...item, disabled }))
            : findBenefitById.products
        const productsGroups =
          findBenefitById.productsGroups && findBenefitById.productsGroups.length
            ? findBenefitById.productsGroups.map((item) => ({
                ...item,
                disabled,
                isGroup: true,
                _id: item.id,
                products: item.products.map((product) => ({
                  ...product,
                  disabled,
                })),
              }))
            : []
        this.campaign = {
          ...findBenefitById,
          startDate: findBenefitById.startDate ? findBenefitById.startDate.substring(0, 10) : '',
          expiresAt: findBenefitById.expiresAt ? findBenefitById.expiresAt.substring(0, 10) : '',
          products: [...products, ...productsGroups],
          minimumValue: formatFloatToString(findBenefitById.minimumValue),
          value: formatFloatToString(findBenefitById.value),
        }
      } catch (error) {
        console.log(error)
        this.$snackbar({ message: 'Erro ao buscar dados no servidor', snackbarColor: 'error' })
      } finally {
        this.isLoadingCampaign = false
      }
    },
    async saveCampaign(draft = false) {
      this.tryingToSaveAsDraft = draft
      this.$v.$reset()
      this.$v.$touch()
      if (this.$v.$error) {
        this.$snackbar({ message: 'Preencha todos os campos corretamente', snackbarColor: 'error' })
        this.$nextTick(() => {
          this.$vuetify.goTo(document.querySelector('.error--text'), { offset: 200 })
        })
        return
      }
      if (typeof this.validCoupon === 'boolean' && !this.validCoupon) return
      if (!draft) {
        const hasProducts = this.campaign.products.length > 0
        if (!hasProducts && this.campaign.productsEnabled) {
          this.$snackbar({ message: 'É necessário adicionar ao menos um produto para ativar ou agendar a campanha', snackbarColor: 'error' })
          return
        }
      }

      try {
        this.loading = true
        await this.$apollo.mutate({
          mutation: draft ? UPSERT_DRAFT_BENEFIT : UPSERT_BENEFIT,
          fetchPolicy: 'no-cache',
          variables: {
            input: {
              ...this.preparePayload,
              active: !draft,
            },
          },
          context: {
            uri: this.$microservicesUrls['benefitsManager'],
          },
        })

        Swal.fire({
          text: 'Campanha salva',
          icon: 'success',
          showConfirmButton: false,
          timer: 1000,
          customClass: {
            content: 'content-class',
          },
        })

        this.$router.push('/campanhas/cupom-desconto').catch(() => {})
      } catch (error) {
        console.log(error)
        Swal.fire({
          text: 'Erro ao salvar campanha',
          icon: 'error',
          showConfirmButton: false,
          timer: 1000,
          customClass: {
            content: 'content-class',
          },
        })
      } finally {
        this.loading = false
      }
    },
    async mutateBenefit(action, name) {
      const id = this.$route.params.id
      const confirm = this.$t(`campanhas.confirmations.${action}`)
      if (name) confirm.message = `Tem certeza que deseja remover a campanha "${name}"`
      const confirmed = await this.$confirm(confirm)
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return

      const actions = {
        unschedule: UNSCHEDULE_BENEFIT,
        finish: FINISH_ACTIVE_BENEFIT,
        delete: DELETE_BENEFIT,
      }
      this.loading = true
      await this.$apollo
        .mutate({
          mutation: actions[action],
          variables: {
            input: { id },
          },
          context: {
            uri: this.$microservicesUrls['benefitsManager'],
          },
        })
        .then(() => {
          this.loading = false
          this.returnToCampaigns()
        })
        .catch(() => {
          this.loading = false
          this.$snackbar(this.$t(`campanhas.snackbars.errors.${action}`))
        })
    },
  },
  validations() {
    const formatFloat = (value) => {
      const formattedValue = value.replace('.', '')
      return parseFloat(formattedValue.replace(',', '.'))
    }
    if (this.tryingToSaveAsDraft) {
      return {
        campaign: {
          title: {
            required,
            minLength: minLength(2),
            notOnlySpace,
          },
          ...(this.campaign.startDate
            ? {
                startDate: {
                  required,
                  isFuture,
                  isBeforeEndDate: function (value, vm) {
                    if (!value || !vm.expiresAt) return false
                    const start = DateTime.fromFormat(value, 'yyyy-MM-dd').toISO()
                    const end = DateTime.fromFormat(vm.expiresAt, 'yyyy-MM-dd').toISO()
                    return start < end
                  },
                },
              }
            : {}),
          ...(formatFloat(this.campaign.minimumValue) > 0
            ? {
                value: {
                  required,
                  minValue: function (value) {
                    return formatFloat(value) > 0
                  },
                },
              }
            : {}),
          ...(formatFloat(this.campaign.value) > 0
            ? {
                minimumValue: {
                  required,
                  minValue: (value, vm) => {
                    return formatFloat(value) >= formatFloat(vm.value) + 1
                  },
                },
              }
            : {}),
        },
      }
    } else {
      return {
        campaign: {
          title: {
            required,
            minLength: minLength(2),
            notOnlySpace,
          },
          description: {
            required,
            minLength: minLength(2),
            notOnlySpace,
          },
          appTitle: {
            required,
            minLength: minLength(2),
            notOnlySpace,
          },
          ...(this.campaign.status !== 'ACTIVE'
            ? {
                startDate: {
                  required,
                  isFuture,
                  isBeforeEndDate: function (value, vm) {
                    if (!value || !vm.expiresAt) return false
                    const start = DateTime.fromFormat(value, 'yyyy-MM-dd').toISO()
                    const end = DateTime.fromFormat(vm.expiresAt, 'yyyy-MM-dd').toISO()
                    return start < end
                  },
                },
              }
            : {
                startDate: {
                  required,
                },
              }),

          expiresAt: {
            required,
            isFuture,
          },
          units: { required },
          ...(this.campaign.variableValidity
            ? {
                daysToUseBenefitAfterRegistration: {
                  required,
                  minValue: minValue(1),
                },
              }
            : {}),
          ...(this.campaign.productsEnabled
            ? {
                minimumProducts: { required, minValue: minValue(1) },
              }
            : {}),
          value: {
            required,
            minValue: function (value) {
              return formatFloat(value) > 0
            },
          },
          minimumValue: {
            required,
            minValue: (value, vm) => {
              return formatFloat(value) >= formatFloat(vm.value) + 1
            },
          },
          code: {
            required,
            minLength: minLength(4),
            maxLength: maxLength(16),
          },
          limitUse: {
            required,
            minValue: minValue(1),
          },
        },
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.date-units-cards {
  display: flex;
  width: 100%;
  gap: 20px;
  align-items: stretch;

  > div {
    flex: 1;
  }
}

::v-deep .table-header-title {
  color: $cinza-d20 !important;
  font-weight: 700 !important;
  font-size: 20px !important;
}
</style>
